// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import { PlusAccordion } from 'components/Gui';
import { breakLine, flex, h201520, h282428, topPadding, Width } from 'styles';

const Wrapper = styled.section`
  ${flex()};
  flex-direction: column;
  ${topPadding(40, 48, 84)};

  h2 {
    ${h282428};
    text-align: center;
    ${breakLine(true, false, false)}
  }
`;

const Mobile = styled.div`
  @media print, screen and (min-width: ${Width.BREAK_MD}px) {
    display: none;
  }

  > div {
    padding: 24px 0;
    border-top: 2px solid #e8e8e8;

    &:first-of-type {
      margin-top: 32px;
    }
  }
`;

const Regular = styled.div`
  display: none;
  @media print, screen and (min-width: ${Width.BREAK_MD}px) {
    ${flex('space-between', 'flex-start')};
    flex-wrap: wrap;
    width: 100%;
    max-width: 800px;
    margin-top: 22px;
  }

  @media print, screen and (min-width: ${Width.BREAK_XL}px) {
    flex-wrap: wrap;
    max-width: unset;
    margin-top: 36px;
  }

  > div {
    flex: 0 0 auto;
    width: calc(50% - 18px);
    margin-top: 32px;

    @media print, screen and (min-width: ${Width.BREAK_XL}px) {
      width: 30.8rem;
      margin-top: 26px;
    }

    h3 {
      display: block;
      height: 4.2rem;
      ${h201520};

      @media print, screen and (min-width: ${Width.BREAK_XL}px) {
        height: 5.8rem;
      }
    }

    p {
      margin-bottom: 0;

      a {
        text-decoration: underline;
      }
    }
  }
`;

const Buttons = styled.div`
  ${flex()};
  margin-top: 48px;
`;

type Props = {
  title: Node | string,
  questions: { q: string | Node, a: string | Node }[],
  buttons?: Node,
};

const MobileOnlyAccordionList = ({ title, questions, buttons, ...rest }: Props) => (
  <Wrapper {...rest}>
    {title}
    <Mobile role="list">
      {questions.map(({ q, a }, index) => (
        <div key={`MobileOnlyAccordionList-${index}`} role="listitem">
          <PlusAccordion a={a} q={q} />
        </div>
      ))}
    </Mobile>
    <Regular role="list">
      {questions.map(({ q, a }, index) => (
        <div key={`MobileOnlyAccordionListWide-${index}`} role="listitem">
          <h3>{q}</h3>
          <p>{a}</p>
        </div>
      ))}
    </Regular>
    {buttons && <Buttons>{buttons}</Buttons>}
  </Wrapper>
);

export default MobileOnlyAccordionList;
